/** @file Stable colour slot (0–7, token --p2-actor-<n>) for an actor name, the same in every panel. */

/** FNV-1a of the name, modulo the eight actor tokens. */
export function actorTone(name: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < name.length; i += 1) h = Math.imul(h ^ name.charCodeAt(i), 0x01000193);
  return (h >>> 0) % 8;
}
